import React from "react";
import { FaMapMarkerAlt, FaSearch } from "react-icons/fa";

export default function FindStoreSection() {
  return (
    <section className="mt-6 px-4 sm:px-6">
      <div className="relative overflow-hidden rounded-lg bg-gradient-to-r from-sky-500 via-indigo-700 to-purple-900 px-5 py-4 text-white shadow-sm sm:px-8 sm:py-10">
        <div className="absolute inset-0 opacity-25">
          <div className="absolute -left-24 -top-20 h-64 w-64 rounded-full bg-white/30 blur-3xl" />
          <div className="absolute -bottom-24 right-10 h-64 w-64 rounded-full bg-black/30 blur-3xl" />
        </div>

        <div className="relative flex flex-col gap-6 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-4">
            <span className="grid h-14 w-14 place-items-center rounded-2xl bg-white/15 ring-1 ring-white/20">
              <FaMapMarkerAlt className="text-2xl" />
            </span>
            <div>
              <h3 className="text-xl font-extrabold tracking-tight sm:text-3xl">
                500+ Items
              </h3>
              <p className="mt-1 text-sm text-white/90 sm:text-base">
                Visit our store & get your desired product!
              </p>
            </div>
          </div>

          <button
            type="button"
            onClick={() => (window.location.hash = "/contact")}
            className="inline-flex w-full items-center justify-center gap-3 rounded-full bg-amber-400 px-7 sm:py-3 py-2 text-sm font-extrabold text-slate-900 shadow-sm transition hover:bg-amber-300 sm:w-auto sm:text-base"
          >
            Find Our Store
            <FaSearch />
          </button>
        </div>
      </div>
    </section>
  );
}
